<div id="chart">
  <apx-chart
    [chart]="chartOptions.chart"
    [fill]="chartOptions.fill"
    [labels]="chartOptions.labels"
    [legend]="chartOptions.legend"
    [plotOptions]="chartOptions.plotOptions"
    [series]="chartOptions.series"
    [stroke]="chartOptions.stroke"
    [theme]="chartOptions.theme"
    [title]="chartOptions.title"
    [yaxis]="chartOptions.yaxis"
  ></apx-chart>
</div>

